import { render, staticRenderFns } from "./ScorecardMra.vue?vue&type=template&id=373fd54c"
import script from "./ScorecardMra.vue?vue&type=script&lang=js"
export * from "./ScorecardMra.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports